'use es6';

export const localDevClassList = {
  SUCCESS: 'hs-local-dev-server--success',
  WARNING: 'hs-local-dev-server--warning',
  FAILURE: 'hs-local-dev-server--failed'
};